import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ errorCode }) => (
  <div className="full-screen">
    <div className="container">
      <p className="error-text">ERROR {errorCode !== 'undefined' ? errorCode : ''}</p>
      <p className="error-message">Oops, something went wrong</p>
      <p className="error-body">Please try again later or return to the <a href="https://www.bestwaywholesale.co.uk/">Bestway homepage</a></p>
    </div>
  </div>
);


Error.propTypes = {
  errorCode: PropTypes.string.isRequired,
};

export default Error;



// WEBPACK FOOTER //
// src/components/molecules/Error/index.jsx